import envConfig from '../../static/config';
import config from '../config';
import HashcodeUtils from './HashcodeUtils';
import ApiUtils from './ApiUtils';
import MoveMoneyActionCreator from '../actions/MoveMoneyActionCreator';
import SavingPotsActionCreator from '../actions/SavingPotsActionCreator';

// Url for Service Call
const _getAccountListEndpoint = '/ibapi/v2/banks/{bank-id}/accounts/default';
const _getPaymentUrl =
  '/ibapi/v2/banks/{bank-id}/accounts/default/{account_id}/mandates/';
const _getPotListEndpoint =
  '/ibapi/v2/banks/{bank-id}/accounts/default/{account_id}/pots';
const _makeSOPaymentUrl =
  '/ibapi/v2/banks/{bank-id}/accounts/default/{account_id}/mandates/so';
const _makeDDPaymentUrl =
  '/ibapi/v2/banks/{bank-id}/accounts/default/{account_id}/transactions';
const _getPayeeList =
  '/ibapi/v2/banks/{bank-id}/accounts/default/beneficiaries';
const _getAccountDetails = '/ibapi/v2/banks/{bank-id}/accounts/default/';
const _getInterPotTransfer =
  '/ibapi/v2/banks/{bank-id}/accounts/default/{account_id}/pots/{potId}/transactions';
const _addPayeeUrl =
  '/ibapi/v2/banks/{bank-id}/accounts/default/{accountId}/beneficiaries/account';

const _validateProfanityUrl =
  '/ibapi/v2/banks/{bank-id}/beneficiaries/validateProfanity';

let useSoftTokenSourceID = false;

const MoveMoneyApiUtils = {
  /**
   * Sets useSoftTokenSourceId flag which is used to determine whether or not to generate a new sourceId or use existingSourceId. (Ideally)
   * @param {Boolean} useSoftTokenSourceID
   */
  isSourceIdSame(data) {
    useSoftTokenSourceID = data;
  },
  /**
   * API call for getAccoountList.
   * Retrieves the list of accounts for a customer.
   */
  getAccountsList() {
    let url = envConfig.apiBaseUrlPAAS + _getAccountListEndpoint;
    if (envConfig.stubConfig) {
      url = envConfig.stubConfig.timelineStub.AccountListConnection;
    }
    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.accountService,
        method: 'GET',
        url,
        addAuthToken: true,
      },
      (body) => {
        MoveMoneyActionCreator.handleAccountsListSuccess(body);
      }
    );
  },
  /**
   * API call for getPayeeList.
   * Retrieves the list of payees.
   */
  getPayeeList() {
    let url = envConfig.apiBaseUrlPAAS + _getPayeeList;
    if (envConfig.isStubsEnabled) {
      url = envConfig.apiBaseUrlStub + _getPayeeList;
    }
    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.paymentServices,
        method: 'GET',
        url,
        addAuthToken: true,
      },
      (body) => {
        MoveMoneyActionCreator.handlePayeesListSuccess(body);
      },
      (error) => {
        MoveMoneyActionCreator.handlePayeeListError(error);
      }
    );
  },
  makeInterPotTransfer(requestBody) {
    let makeTransferUrl = _getInterPotTransfer.replace(
      '{account_id}',
      requestBody.selectedAccountId
    );
    const requestData = requestBody.requestData;
    makeTransferUrl = makeTransferUrl.replace(
      '{potId}',
      requestBody.selectedPotId
    );
    let url = envConfig.apiBaseUrlPAAS + makeTransferUrl;
    if (envConfig.stubConfig) {
      // TODO need to discuss with the team
      url = envConfig.stubConfig.paymentStub.MakePaymentConnection;
    }
    if (useSoftTokenSourceID === true) {
      requestData.source_id = HashcodeUtils.getSourceIdForSoftToken();
      useSoftTokenSourceID = false;
    } else requestData.source_id = HashcodeUtils.getSourceId(requestData);
    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.paymentServices,
        // Todo change it to post when webservice is there in place
        method: envConfig.stubConfig ? 'Get' : 'POST',
        url,
        addAuthToken: true,
        requestData,
      },
      (bodys) => {
        const body = bodys;
        body.code = 202;
        MoveMoneyActionCreator.handleMakePaymentServiceCall(body);
      },
      (errors) => {
        if (errors !== undefined) {
          const error = errors;
          error.code = 422;
          MoveMoneyActionCreator.handleMakePaymentServiceCall(error);
        } else {
          MoveMoneyActionCreator.handleMakePaymentServiceCall({ code: 422 });
        }
      }
    );
  },
  async isAbusiveReference(requestData) {
    return new Promise((resolve) => {
      ApiUtils.makeAjaxCall(
        {
          apiVersion: config.apiVersions.paymentServices,
          method: 'POST',
          url: `${envConfig.apiBaseUrlPAAS}${_validateProfanityUrl}`,
          addAuthToken: true,
          requestData,
        },
        ({ isValid }) => {
          resolve(isValid);
        }
      );
    });
  },
  makePayment(requestBody) {
    let url = envConfig.apiBaseUrlPAAS + _getPaymentUrl;
    if (envConfig.stubConfig) {
      // TODO need to discuss with the team
      url = envConfig.stubConfig.paymentStub.MakePaymentConnection;
    }
    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.paymentServices,
        // Todo change it to post when webservice is there in place
        method: 'Get',
        url,
        addAuthToken: true,
        requestBody,
      },
      (bodys) => {
        const body = bodys;
        body.code = 202;
        MoveMoneyActionCreator.handleMakePaymentServiceCall(body);
      },
      (errors) => {
        if (errors !== undefined) {
          const error = errors;
          error.code = 422;
          MoveMoneyActionCreator.handleMakePaymentServiceCall(error);
        } else {
          MoveMoneyActionCreator.handleMakePaymentServiceCall({ code: 422 });
        }
      }
    );
  },
  getAccountDetails(account_number) {
    let url = envConfig.apiBaseUrlPAAS + _getAccountDetails + account_number;
    if (envConfig.stubConfig) {
      const key = `AccountDetailsConnection-${account_number}`;
      url = envConfig.stubConfig.timelineStub[key];
    }

    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.accountService,
        method: 'GET',
        url,
        addAuthToken: true,
      },
      (bodys) => {
        const body = bodys;
        body.code = 401;
        MoveMoneyActionCreator.handleAccountsDetailsSuccess(body);
      },
      (errors) => {
        if (errors !== undefined) {
          const error = errors;
          error.code = 422;
          MoveMoneyActionCreator.handleAccountsDetailsSuccess(error);
        } else {
          MoveMoneyActionCreator.handleAccountsDetailsSuccess({ code: 422 });
        }
      }
    );
  },

  getPotDetails(account_number) {
    let url = envConfig.apiBaseUrlPAAS + _getPotListEndpoint;
    url = url.replace('{account_id}', account_number);
    if (envConfig.stubConfig) {
      const key = `GetPotsConnection-${account_number}`;
      url = envConfig.stubConfig.paymentStub[key];
    }
    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.paymentServices,
        method: 'GET',
        url,
        addAuthToken: true,
      },
      (body) => {
        const resp = {
          id: account_number,
          pots: body,
        };
        MoveMoneyActionCreator.handlePotsDetailsSuccess(resp);
        SavingPotsActionCreator.handlePotDataRejigSuccess(resp);
      },
      (error) => {
        // handle error
      }
    );
  },
  makeDDPayment(requestBody) {
    const makePaymentUrl = _makeDDPaymentUrl.replace(
      '{account_id}',
      requestBody.accountId
    );
    let url = envConfig.apiBaseUrlPAAS + makePaymentUrl;
    if (envConfig.stubConfig) {
      // TODO need to discuss with the team
      url = envConfig.stubConfig.paymentStub.MakePaymentConnection;
    }
    const requestData = requestBody.makePaymentRequestDD;
    if (useSoftTokenSourceID === true) {
      requestData.source_id = HashcodeUtils.getSourceIdForSoftToken();
    } else requestData.source_id = HashcodeUtils.getSourceId(requestData);
    requestData.tags = ['11111111-2222-3333-4444-555555555555'];

    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.paymentServices,
        method: envConfig.stubConfig ? 'Get' : 'POST',
        url,
        addAuthToken: true,
        requestData,
      },
      (bodys) => {
        const body = bodys;
        body.code = 202;
        MoveMoneyActionCreator.handleMakePaymentServiceCall(body);
      },
      (errors) => {
        if (errors !== undefined) {
          const error = errors;
          error.code = 422;
          MoveMoneyActionCreator.handleMakePaymentServiceCall(error);
        } else {
          MoveMoneyActionCreator.handleMakePaymentServiceCall({ code: 422 });
        }
      }
    );
  },
  makeSOPayment(requestBody) {
    const makePaymentUrl = _makeSOPaymentUrl.replace(
      '{account_id}',
      requestBody.accountId
    );
    let url = envConfig.apiBaseUrlPAAS + makePaymentUrl;
    if (envConfig.stubConfig) {
      // TODO need to discuss with the team
      url = envConfig.stubConfig.paymentStub.MakePaymentConnection;
    }

    const requestData = requestBody.makePaymentRequest;
    if (useSoftTokenSourceID === true) {
      requestData.source_id = HashcodeUtils.getSourceIdForSoftToken();
    } else requestData.source_id = HashcodeUtils.getSourceId(requestData);
    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.mandateService,
        method: envConfig.stubConfig ? 'Get' : 'POST',
        url,
        addAuthToken: true,
        requestData,
      },
      (bodys) => {
        const body = bodys;
        body.code = 202;
        MoveMoneyActionCreator.handleMakePaymentServiceCall(body);
      },
      (errors) => {
        if (errors !== undefined) {
          const error = errors;
          error.code = 422;
          MoveMoneyActionCreator.handleMakePaymentServiceCall(error);
        } else {
          MoveMoneyActionCreator.handleMakePaymentServiceCall({ code: 422 });
        }
      }
    );
  },
  makeSingleUsePayee(requestBody) {
    const addPayeeUrl = _addPayeeUrl.replace(
      '{accountId}',
      requestBody.selectedAccountId
    );
    let url = envConfig.apiBaseUrlPAAS + addPayeeUrl;
    const requestData = requestBody.requestData;
    if (envConfig.stubConfig) {
      url = envConfig.stubConfig.paymentStub.AddPayeeConnection;
    }
    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.payeeService,
        method: envConfig.stubConfig ? 'Get' : 'POST',
        url,
        requestData,
        addAuthToken: true,
      },
      (bodys) => {
        const body = bodys;
        body.code = 201;
        MoveMoneyActionCreator.handleSingleUsePayee(body, requestBody);
      },
      (errors) => {
        if (errors !== undefined) {
          const error = errors;
          error.code = 422;
          MoveMoneyActionCreator.handleMakePaymentServiceCall(error);
        } else {
          MoveMoneyActionCreator.handleMakePaymentServiceCall({ code: 422 });
        }
      }
    );
  },
};

export default MoveMoneyApiUtils;
